export default {
  productQuantity: [],
  products: {},
  mallType: 3,
};
